import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "add-todo" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "text-input text-input--focus" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "button button--filled" }, "Add task", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isFormVisible)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "add-todo__form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)), ["prevent"]))
        }, [
          _createElementVNode("button", {
            class: "close-button",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
          }, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemText) = $event)),
              class: "input"
            }, null, 512), [
              [_vModelText, _ctx.itemText]
            ])
          ]),
          _hoisted_5
        ], 32))
      : (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "add-todo__show-form-button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showForm && _ctx.showForm(...args)))
        }, _hoisted_7))
  ]))
}